import styled from '@emotion/styled';
import { Typography } from 'antd';

export const PageTitle = styled(Typography.Title)`
  margin: 0;
`;
